// extracted by mini-css-extract-plugin
export var h1 = "styles-module--h1--QlgqG";
export var bold = "styles-module--bold--Xl0jG";
export var light = "styles-module--light--ZNSe-";
export var h2 = "styles-module--h2--MyGL6";
export var h3 = "styles-module--h3--83avX";
export var h4 = "styles-module--h4--QtN-X";
export var h5 = "styles-module--h5--SODkq";
export var copy = "styles-module--copy--5bDup";